<div class="fdm-briefcase fdm-dialog fdm-fade" id="panel-camera-bookmarks" [hidden]="!show">

  <mat-card *ngIf="show" class="fdm-dropdown-panel" style="box-shadow: 0 0 200px 50px rgb(52, 52, 68);">

    <!-- Add data -->
    <mat-card-header class="header">
      <div class="subheading-2 title">{{ 'MAP.CAMERA_BOOKMARKS' | translate }}</div>
      
      <div class="header-actions">
        
        <!-- Close dialog -->
        <fa-icon class="fdm-link" icon="times" style="font-size:22px;margin-right:5px;" (click)="close()"></fa-icon>
      
      </div>
    </mat-card-header>

    <!-- Drag/drop files -->
    <mat-card-content class="content" *ngIf="sceneController.activeCameraPositions">

        <table class="category fdm-sidebar-table-list">

          <!-- <tr>
            <th></th>
            <th style="text-align:center;font-size:30px;"><fa-icon icon="users"></fa-icon></th>
            !-- <th style="text-align:center;font-size:30px;"><fa-icon icon="user"></fa-icon></th> --
          </tr> -->

          <ng-container *ngFor="let category of sceneController.activeCameraPositions | keyvalue">
            <ng-container *ngIf="category.key !== 'counter'">
              <ng-container *ngFor="let item of category.value">

                <tr>
                  <td *ngIf="item.category == 'project'">{{ 'MAP.PROJECT' | translate }}</td>
                  <td *ngIf="item.category == 'scene'">{{ 'MAP.SCENE' | translate }}</td>
                  <td *ngIf="item.category == 'transform'">{{ item.data.obj.name }}</td>

                  <!-- when we're ready for user properties; ['global','user'] -->
                  <td *ngFor="let type of ['global']" class="data" [class.isActive]="item.data[type].camera" style="width:35%;">
          
                    <ng-container *ngIf="!item.data[type].camera">
                      <fa-icon icon="plus" class="fdm-link" (click)="add(item)"></fa-icon>
                    </ng-container>
                    <ng-container *ngIf="item.data[type].camera">
                      <fa-icon icon="camera" class="fdm-link" (click)="capture(item)"></fa-icon>
                      <span class="fdm-progress-flap note fdm-fade" [ngStyle]="{ 'opacity': item.captured ? 1 : 0 }">{{ 'MAP.CAMERA_BOOKMARKS_CAPTURED' | translate }}</span>
                      <fa-icon icon="paper-plane" class="fdm-link" (click)="flyTo(item)"></fa-icon>
                      <fa-icon icon="times" style="color:red;" class="fdm-link" (click)="delete(item)"></fa-icon>
                    </ng-container>
                    
                  </td>
                </tr>

                <tr *ngIf="item.category == 'scene'">
                  <td class="isTransforms" colspan="2"><hr></td>
                </tr>

              </ng-container>
            </ng-container>
          </ng-container>

        </table>

    </mat-card-content>
  </mat-card>

</div>



<!--
<div class="fdm-briefcase" *ngIf="sceneController.activeCameraPositions">
  <div class="category">
    <label></label>
    <div>
      <span class="isHeader"><fa-icon icon="users"></fa-icon></span>
      <span class="isHeader"><fa-icon icon="user"></fa-icon></span>
    </div>
  </div>
  <ng-container *ngFor="let category of sceneController.activeCameraPositions | keyvalue">
    
    <table class="category fdm-sidebar-table-list" *ngIf="category.key !== 'counter'">
      <tr>
        <th></th><th><fa-icon icon="users"></fa-icon></th><th><fa-icon icon="user"></fa-icon></th>
      </tr>

      <tr *ngFor="let item of category.value">
        <td>{{item.category}} [{{item.id}}]</td>
        <td *ngFor="let data of ['global','user']">

          <span [class.isActive]="data.camera">
            <ng-container *ngIf="!data.camera">
              <fa-icon icon="plus" class="fdm-link"></fa-icon>
            </ng-container>
            <ng-container *ngIf="data.camera">
              <fa-icon icon="camera" class="fdm-link"></fa-icon>
              <fa-icon icon="paper-plane" class="fdm-link"></fa-icon>
              <fa-icon icon="times" style="color:red;" class="fdm-link"></fa-icon>
            </ng-container>
          </span>
          
        </td>
      </tr>

      !-- <label>[{{ category.key }}]</label>
      <div>
        <span *ngFor="let item of category.value" [class.isActive]="item.camera" [class.isGlobal]="item.type == 'global'" [class.isUser]="item.type == 'user'">
          <ng-container *ngIf="!item.camera">
            <fa-icon icon="plus" class="fdm-link"></fa-icon>
          </ng-container>
          <ng-container *ngIf="item.camera">
            <fa-icon icon="camera" class="fdm-link"></fa-icon>
            <fa-icon icon="paper-plane" class="fdm-link"></fa-icon>
            <fa-icon icon="times" style="color:red;" class="fdm-link"></fa-icon>
          </ng-container>
        </span>
      </div> --

    </table>

  </ng-container>
</div>
-->